<template>
  <div v-if="$store.state.ui.currentWorkspace?.short_id == $route.params?.wid && $route.params?.page">
    <TripleMenu
      v-if="$route.params?.page"
      :set-edit-mode="setEditMode"
      :edit-mode-active="edit_mode_active"
      :quick-actions="top_right_menu_quick_actions"
      :components-actions="top_right_menu_components_actions"
      :current-template="current_template"
      :page-reference="PAGE_REFERENCES.WORKSPACE" />

    <div
      :style="{
        backgroundColor: $store.state.ui.currentWorkspace?.header_color
      }"
      class="fixed flex items-center w-full h-32 space-x-6 bg-black top-20">
      <div
        :style="{
          color: $store.state.ui.currentWorkspace?.header_text_color
        }"
        class="ml-6 text-xl font-medium">
        {{ $store.state.ui.currentWorkspace?.name }}
      </div>

      <Logo v-if="!$store.state.ui.currentWorkspace?.logo" class="inline-block p-3 rounded-md cursor-default h-28 w-28" />
      <img v-else class="inline-block h-24 p-3 rounded-lg" :src="$store.state.ui.currentWorkspace?.logo" alt="">
    </div>

    <div
      v-if="$store.state.ui.currentWorkspace"
      :style="{
        backgroundColor:
          $store.state.ui.currentWorkspace?.page_background_color == 'transparent'
            ? ''
            : $store.state.ui.currentWorkspace?.page_background_color
      }">
      <ModuleIcon class="absolute w-0 h-0" />
      <div class="!mt-32">
        <PagesTabs />
      </div>
      <LayoutContainer
        v-model:current-template="current_template"
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        class="mt-20 !h-[calc(100vh-285px)]"
        :page-reference="PAGE_REFERENCES.WORKSPACE" />
    </div>
  </div>
  <div v-else class="mt-[125px] ml-20">
    {{ $t("Loading workspace...") }}
  </div>
</template>

<script>
import dataService from "@/services/data.service"
import TripleMenu from "@/components/shared/TripleMenu.vue"
import Logo from "@/components/shared/Logo.vue"
import { PAGE_REFERENCES } from "@/store/constants/references"
import LayoutContainer from "@/components/shared/pages/LayoutContainer.vue"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import { ClipboardList, Mail, Folder, TrendingUp, MessagesSquare, List, ChartNoAxesColumnDecreasing } from "lucide-vue-next"
import PagesTabs from "@/components/shared/PagesTabs"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { TripleMenu, LayoutContainer, ModuleIcon, Logo, PagesTabs },
  props: {},
  emits: [],
  data() {
    return {
      PAGE_REFERENCES,
      edit_mode_active: false,
      current_template: null
    }
  },

  computed: {
    top_right_menu_quick_actions() {
      return [
        {
          name: this.$t("Create a Group"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_NEW_GROUP)
          },
          disabled: false,
          icon: Folder
        },
        {
          name: this.$t("Create a Plan"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN, {
              record: this.$store.state.ui.currentWorkspace.record
            })
          },
          disabled: false,
          icon: List
        },
        {
          name: this.$t("Create a Goal"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_GOAL, {
              record: this.$store.state.ui.currentWorkspace.record
            })
          },
          disabled: false,
          icon: TrendingUp
        },
        {
          name: this.$t("Create a Task"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_TASK, {
              record: this.$store.state.ui.currentWorkspace.record
            })
          },
          disabled: false,
          icon: ClipboardList
        },
        {
          name: this.$t("Create an Interaction"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION, {
              record: this.$store.state.ui.currentWorkspace.record
            })
          },
          disabled: false,
          icon: MessagesSquare
        },
        {
          name: this.$t("Send Email"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL)
          },
          disabled: false,
          icon: Mail
        },

        {
          name: this.$t("Create a Custom Metric"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_CUSTOM_METRIC, { view_type: "table" })
          },
          disabled: false,
          icon: ChartNoAxesColumnDecreasing
        }
      ]
    },
    top_right_menu_components_actions() {
      return [
        {
          name: this.$t("Edit Layout"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.EDIT_LAYOUT, {
              page_reference: PAGE_REFERENCES.WORKSPACE,
              page_name: this.$route.params.page
            })
          },
          disabled: false,
          keyBoardShortcut: "I",
          icon: ModuleIcon
        },
        {
          name: this.$t("Add/Remove Components"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, {
              page_reference: PAGE_REFERENCES.WORKSPACE,
              current_template: this.current_template
            })
          },
          disabled: false,
          keyBoardShortcut: "U",
          icon: ModuleIcon
        }
      ]
    }
  },
  watch: {},

  created() {
    this.init()
  },

  methods: {
    init() {
      if (this.$route.params.wid && this.$route.name == "WorkspaceItem") {
        // this.$store.dispatch("ui/setCurrentWorkspace", null)
        dataService.getWorkspace(this.$route.params.wid).then((res) => {
          this.$store.dispatch("ui/setCurrentWorkspace", res.data)
          this.current_template = this.$store.state.ui.currentWorkspace?.layout.find((l) => l.id == this.$route.params?.page)
          if (!this.$route.params.page) {
            this.$router.replace(
              `/workspace/${this.$store.state.ui.currentWorkspace?.short_id}/${
                this.$store.state.ui.currentWorkspace?.layout.filter((l) => l.is_visible)[0]?.id
              }`
            )
            this.current_template = this.$store.state.ui.currentWorkspace?.layout.find((l) => l.id == this.$route.params?.page)
          }
        })
      }
    },

    setEditMode(value) {
      this.edit_mode_active = value
    }
  }
}
</script>
